module.exports = __webpack_public_path__ + "media/applicants/info-1daa549d.png";